import { render } from "./Banners.vue?vue&type=template&id=408ea721&scoped=true&ts=true"
import script from "./Banners.vue?vue&type=script&lang=ts"
export * from "./Banners.vue?vue&type=script&lang=ts"

import "./Banners.vue?vue&type=style&index=0&id=408ea721&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408ea721"]])

export default __exports__